import { render, staticRenderFns } from "./ClientHistoryPackages.vue?vue&type=template&id=f7880ee6&scoped=true"
import script from "./ClientHistoryPackages.vue?vue&type=script&lang=js"
export * from "./ClientHistoryPackages.vue?vue&type=script&lang=js"
import style0 from "./ClientHistoryPackages.vue?vue&type=style&index=0&id=f7880ee6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7880ee6",
  null
  
)

export default component.exports